import React, {Component} from 'react';
import {injectIntl} from "react-intl";
import withAuthorization from "../../services/Authorization";
import DealershipInformation from "./DealershipInformation";
import GeneralServices from "./GeneralServices";
import MainServices from "./MainServices"
import Mobility from "./Mobility";
import OpeningHours from "./OpeningHours";
import PlanningConfiguration from "./PlanningConfiguration";
import Tires from "./Tires";

import './Dealership.css';

class Dealership extends Component {

  render(){
    const {intl:{formatMessage}} = this.props;

    return(
      <div>
        <header className="main-header">
          <div className="main-header__left">
            <h1 className="main__title">
              {formatMessage({id:'page.dealer-data'})}
            </h1>
          </div>
        </header>
        <div className="main__content">
          <DealershipInformation/>
          <PlanningConfiguration/>
          <GeneralServices/>
          <OpeningHours/>
          <MainServices/>
          <Tires/>
          <Mobility/>
        </div>
      </div>
    )
  }
}

export default injectIntl(withAuthorization(Dealership, ['DUI_ADMIN', 'DUI_SERVICE_ADVISOR']));
